module.exports = __webpack_public_path__ + "media/images/sales/early/icon-mv-ae1d3b3cf05b10198a0c13f4e07b912c.svg";